import React, { useContext, useEffect } from "react";
import { get } from "../../../../logics/src/utils/helpers";
import { Main } from "pages/Payment/assets/style";
import { SavePaymentView } from "./SavePaymentView";
import { PaymentContext } from "wrapper/PaymentWrapper/context/paymentContext";
import { getStringFromId } from "../../../../helpers/vernacular";
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import { PlaceOrderButton } from "./PlaceOrderButton";
import { PAYMENT_OPTION, PAYMENT_SCREENS } from "constants/paymentScreens";
import { useHistory } from "react-router-dom";
import { getPaymentOffers } from "layouts/Payment/common/dependencies/dependencyhelpers";
import { getIsSavedMethodsDisplayed } from "wrapper/PaymentWrapper/dependencies/helper";
import { useTheme } from "emotion-theming";
import { UserContext } from "wrapper/UserWrapper/context";
import { ApplicationContext } from "wrapper/ApplicationWrapper/context";
import { ErrorModalContext } from "wrapper/ErrorModalWrapper/context";
import { shouldAppendBuyNowApiParam as isBuyNowFlow } from "helpers/utils/buyNowCheckoutFlow";
import { VerifyOtpContext } from "wrapper/VerifyOtpWrapper/context";
import { setCheckoutSuccessToFalseInDataLayer, trackPayNowClick } from "layouts/Payment/common/dependencies/tracking";
import { doPaymentHandler } from "layouts/Payment/logics/doPaymentHandler";
import { windowScrollToTop } from "helpers/utils/scrollTop";
import { getSavedOffer } from "../../../../logics/src/utils/checkOffers";
import { usePriceDetailsConfig } from "../../../../hooks/usePriceDetailsConfig";
import {
  trackInfoIconClick,
  trackPaymentDetailClick,
} from "layouts/Payment/common/dependencies/tracking";
import { noMargin } from "../NewPaymentDetails/assets/borderRadius";
import { checkIsConvenienceChargesExperimentEnabled, getPlatform } from "../../../../helpers";
import { PAYMENT_MODES } from "constants/paymentModes";
import { ExperimentAndSwitchContext } from "wrapper/ExperimentAndSwitchWrapper/context";
import { PAGE_NAMES, PAGE_TYPES, TRACKING_EVENTS, ANALYTICS_KEYS } from "constants/index";
import { getBucketSize } from "helpers/utils/getBucketSize";
import { checkIsNewPaymentMethodVisibleOnScreen1, getAvailablePaymentMethodOnSavedPaymentScreen, checkAllUpiIntentVisibilityOnWeb, getCodAvailableAttributes } from "layouts/CheckoutPayment/helpers";
import { trackPayment1PageLoad } from "layouts/Payment/common/dependencies/tracking";
import { NO_SAVED_METHOD } from "constants/dataLayer";
import {
  allTrackingHandlerForApps,
  getRetinaPayment1LoadData,
  triggerRetinaEventForWeb,
} from "helpers/utils/trackingHandler";
import { ZEST_MONEY_EXPERIMENT } from "layouts/Payment/common/dependencies/constants";
import { NewPaymentFailureFlow } from "layouts/PaymentFailure/NewPaymentFailureFlow";
import { CommonContextContext } from "wrapper/CommonWrapper/context";
import { DiscountInfoStrip } from "components/DiscountInfoStrip";
import { formatNumber } from "helpers/utils/numberFormatter";
import { SavePaymentBuyNowView } from "./SavePaymentBuyNowView";


interface IAllSavedPaymentMethod {
  isVisible: boolean;
  setIsWalletChecked: any;
  setPaymentScreen: any;
  timerCallback: any;
  setUpiDetails: any;
  isGPayIntentAvailable: boolean;
  loading: boolean;
  showAllPaymentMethods: boolean;
  showFallbackModeSheet: boolean;
  setShowFallbackModeSheet: (value: boolean)=>void;
  isGPayIntentLoading: boolean;
  isDeliveryEstimateToastVisible: boolean;
  setIsDeliveryEstimateToastVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const AllSavedPaymentMethod = ({
  isVisible,
  setIsWalletChecked,
  setPaymentScreen,
  timerCallback,
  setUpiDetails,
  isGPayIntentAvailable,
  loading,
  showAllPaymentMethods,
  showFallbackModeSheet,
  setShowFallbackModeSheet,
  isGPayIntentLoading,
  isDeliveryEstimateToastVisible,
  setIsDeliveryEstimateToastVisible,
}: IAllSavedPaymentMethod) => {
  const history = useHistory();
  const platform = getPlatform();
  const theme: Theme = useTheme();
  const paymentContext = useContext(PaymentContext);
  const { userData } = useContext(UserContext);
  const { applicationData } = useContext(ApplicationContext);
  const errorModalContext = useContext(ErrorModalContext);
  const {
    EDD,
    NewPaymentFailure,
    NewPaymentMethodOnPaymentScreen1,
    UpiIntentMweb,
    DiscountInfoStripExp,
    NewAddressDesignExp,
  } = useContext(ExperimentAndSwitchContext);
  const {
    setIsVerifyOtpVisible,
    isOtpVerificationRequired,
    handleCallBackAfterVerification,
  } = useContext(VerifyOtpContext);
  const {
    commonData: { isFirstLandingPageAfterCheckout },
    setIsFirstLandingPageAfterCheckout,
  } = useContext(CommonContextContext);
  const walletConfig = paymentContext?.walletConfig;
  const giftCardConfig = paymentContext?.giftCardInfoConfig;
  const orderAmount = paymentContext?.orderAmount;

  const cartInfo = get(paymentContext, "cartInfo");
  const paymentInfo = get(paymentContext, "paymentInfo");
  const upiIntentList = get(paymentContext, "upiIntentList");
  const cartErrorMessage = get(paymentContext, "cartInfo.cartErrorMessage");
  const grandTotal = get(cartInfo, "grandTotal");
  const walletBalance = get(walletConfig, "walletBalance");
  const isFullPaymentByGiftCard = get(giftCardConfig, "isFullPaymentByGiftCard");
  const offersData: any = get(paymentContext, "offersData");
  const { isGuest } = userData;
  const flow = get(paymentContext, "flow");
  const flowConfig = get(paymentContext, "flowConfig");
  const { deviceType, isApp } = applicationData;
  const openErrorModal = get(errorModalContext, "openErrorModal");
  const setLoading = get(paymentContext, "setLoading");
  const doPaymentApi = get(paymentContext, "doPaymentApi");
  const walletInfo = get(paymentContext, "walletInfo");
  const products = get(cartInfo, "items");
  const isPaymentInfoLoading = paymentContext?.isPaymentInfoLoading;
  // const [showSavedOffers, setShowSavedOffers] = ueState(true);
  const setIsAutoCreateOrderLoading = get(paymentContext, "setIsAutoCreateOrderLoading");
  // used for hiding circular loader in paymentFailureFlow
  const failureFlowEnabled = NewPaymentFailure?.switchEnabled && NewPaymentFailure?.experimentEnabled;
  const isNewAddressDesignEnabled = NewAddressDesignExp?.switchEnabled && NewAddressDesignExp?.experimentEnabled;
  const isFailureUrl = failureFlowEnabled && window?.location?.href?.includes("paymentFailureOrderId");
  const isSavedPayment = get(paymentContext, "paymentResponseV2Data.isSavedPayment");
  const codHandlingCharge = paymentContext?.codHandlingCharge;
  const isCodMethodSelected = paymentContext?.isCodMethodSelected;
  const setPaymentOption = paymentContext?.setPaymentOption;
  const availablePaymentMethods = get(cartInfo, "availablePaymentMethods");
  const isCodAvailable = cartInfo?.isCodAvailable;
  const cashFreePaymentGateway = get(cartInfo, "paymentGateway");
  const totalSaved = Math.round(get(cartInfo, "totalSaved"));
  const showDiscountInfoStrip = !!(totalSaved && DiscountInfoStripExp?.switchEnabled && DiscountInfoStripExp?.experimentEnabled);
  const newPaymentMethod = getAvailablePaymentMethodOnSavedPaymentScreen({ availablePaymentMethods, isCodAvailable });
  const isNewPaymentMethodVisible = checkIsNewPaymentMethodVisibleOnScreen1({
    isExperimentEnable: NewPaymentMethodOnPaymentScreen1.experimentEnabled,
    grandTotal,
    flow,
    availablePaymentMethods,
    isCodAvailable,
    cartErrorMessage,
  });
  const isAllUpiIntentAvailableOnWeb = checkAllUpiIntentVisibilityOnWeb({
    availablePaymentMethods,
    isExperimentEnable: UpiIntentMweb.experimentEnabled && UpiIntentMweb.switchEnabled,
    cashFreePaymentGateway,
  });
  
  let {
    savedCardsDisplayed: areSavedPaymentMethodsDisplayed,
    savedMethodsAvailable,
  } = getIsSavedMethodsDisplayed(
    cartInfo,
    paymentInfo,
    upiIntentList,
    isGPayIntentAvailable,
    isAllUpiIntentAvailableOnWeb
  );  
  const isSavedPaymentVisible = flowConfig?.showPaymentView && areSavedPaymentMethodsDisplayed;

  const requestParams = {
    cartInfo,
    paymentInfo,
    isGuest,
    history,
    flow,
    deviceType,
    isOtpVerificationRequired,
    isApp,
    applyCartCharges: checkIsConvenienceChargesExperimentEnabled(),
  };
  useEffect(() => {
    /* eslint-disable no-unused-vars, @typescript-eslint/no-unused-vars */
    const offers = getSavedOffer(paymentInfo, offersData);
    // setShowSavedOffers(!offers?.length);
  }, [paymentInfo, offersData]);
  const callbacks = {
    setLoading,
    setIsAutoCreateOrderLoading,
    openErrorModal,
    trackPayNowClick: trackPayNowClick,
    setIsVerifyOtpVisible,
    handleCallBackAfterVerification,
    doPaymentApi,
    history,
  };
  const doPaymentInterceptor = () => {
    doPaymentHandler(PAYMENT_MODES.COD, { giftCardConfig, walletConfig }, requestParams, callbacks);
    windowScrollToTop();
  };
  let proceedToPayVisible = false;
  let proceedToPayText = getStringFromId(
    VERNACULAR_STRING_IDS.PROCEED_TO_PAY,
    VERNACULAR_DEFAULT_MESSAGES.PROCEED_TO_PAY
  );
  const placeOrder = getStringFromId(
    VERNACULAR_STRING_IDS.PLACE_ORDER,
    VERNACULAR_DEFAULT_MESSAGES.PLACE_ORDER
  );
  // displaying wallet incase of no saved payment methods and wallet sufficient balance
  let isWalletDisplayed = areSavedPaymentMethodsDisplayed || isNewPaymentMethodVisible;
  if (
    walletBalance &&
    walletBalance > 0 &&
    walletBalance >= grandTotal &&
    grandTotal > 0 &&
    !cartErrorMessage
  ) {
    // wallet multimodal case
    isWalletDisplayed = true;
  }
  // Proceed/Place order button visibility and text handling
  if (
    !areSavedPaymentMethodsDisplayed &&
    !isWalletDisplayed &&
    !isNewPaymentMethodVisible && 
    !isGPayIntentLoading
  ) {
    proceedToPayVisible = true;
    if (grandTotal <= 0 && !isFullPaymentByGiftCard) {
      proceedToPayText = placeOrder;
    }
  }
  // Function to provide no Margin according to the payment page
  let noMarginOnNewPaymentDetail = noMargin(PAYMENT_SCREENS.SAVED);
  const priceDetailConfig = usePriceDetailsConfig({
    isGuest,
    theme,
    cartInfo,
    callbacks: {
      trackToggleAccordian: (expanded: boolean) => {
        trackPaymentDetailClick(PAYMENT_SCREENS.SAVED, expanded);
        // tracking apps price details expand
        allTrackingHandlerForApps({
          event: TRACKING_EVENTS.PRICE_DETAILS_TOOPTOP_EXPAND,
          interactionLocation: PAGE_NAMES.SAVED_PAYMENT_PAGE,
          isExpanded: expanded,
          isApp,
        });
      },
      trackInfoIconClick: (type: string) => {
        trackInfoIconClick(PAYMENT_SCREENS.SAVED, type);
      },
    },
    orderAmount: cartInfo?.grandTotal,
    codHandlingCharge,
    isCodMethodSelected,
    noMargin: noMarginOnNewPaymentDetail,
    initialAccordianState: true,
    platform,
  });

  const discountText = getStringFromId(
    VERNACULAR_STRING_IDS.DYNAMIC_YOU_ARE_SAVING_AMOUNT,
    `You are saving <span class="font-medium" style="color: ${theme?.colors.positive};">₹${formatNumber(totalSaved)}</span> on this order`,
    { totalSaved: `<span class="font-medium" style="color: ${theme?.colors.positive};">₹${formatNumber(totalSaved)}</span>` }
  );

  /**
   * This block is for trancking event on page load
   */
  useEffect(() => {
    if (Array.isArray(products) && products?.length !== 0 && isVisible && !isPaymentInfoLoading) { // tracking should be fired after getInfo response
      const offers = getSavedOffer(paymentInfo, offersData);
      const visibleOffers = !offers?.length;
      const savedMethodString = savedMethodsAvailable.length && savedMethodsAvailable.join(", ");
      const zestVariant = ZEST_MONEY_EXPERIMENT.VISIBILITY; // 'Z_VISIBILITY experiment is always visible
      const cartConvenienceChargesBreakupDto = cartInfo?.cartConvenienceChargesBreakupDto;
      const trackingEvents = {
        page: PAGE_NAMES.SAVED_PAYMENT_PAGE,
        page_type: PAGE_TYPES.PAYMENT_PAGE,
        currency: cartInfo?.currencyCode,
        cart_value_bucket: getBucketSize(cartInfo?.grandTotal || 0),
        savedPaymentMethodsAvailable: areSavedPaymentMethodsDisplayed
          ? savedMethodString
          : NO_SAVED_METHOD,
        verificationRequired: get(walletInfo, "isVerificationRequired"),
        isScWalletEnabled: get(walletInfo, "scWalletEnabled"),
        discountApplied: cartInfo?.totalSaved,
        cartItemCount: cartInfo?.paymentDetails?.itemCount,
        cartProductCount: cartInfo?.quantity,
        zestExperiment: zestVariant,
        ab_Edd_checkout: EDD?.switchEnabled,
        cartShipping: cartInfo?.shippingCharge,
        cartSubTotal: cartInfo?.subTotal,
        cartDiscount: cartInfo?.bagDiscount,
        cartTotal: cartInfo?.grandTotal,
        cartCouponDiscount: cartInfo?.couponDiscount,
        products,
        payment_available_offers: getPaymentOffers(offersData?.paymentRules),
        flow,
        is_logged_in: !isGuest,
        price_detail_expanded: priceDetailConfig.isAccordianOpened,
        is_payment_offer_visible: visibleOffers,
        is_new_upi_intent: isAllUpiIntentAvailableOnWeb,
        is_payment_failure_enabled: failureFlowEnabled,
        isFirstLandingPageAfterCheckout: isFirstLandingPageAfterCheckout,
        is_discount_info_strip_shown: showDiscountInfoStrip,
        isNewAddressDesignEnabled: isNewAddressDesignEnabled,
        bagTotal: cartInfo?.bagTotal,
        shippingCharge: cartInfo?.shippingDataDto?.appliedShippingDTO?.shippingCharges,
        ruleDiscountWithoutLabel: cartInfo?.ruleDiscountWithoutLabel,
        couponCode: cartInfo?.paymentDetails?.couponCode,
        packagingDeliveryFee: cartConvenienceChargesBreakupDto?.find((item: any) => item.analyticsKey === ANALYTICS_KEYS.PACKAGING_DELIVERY_FEE)?.amount,
        platformFee: cartConvenienceChargesBreakupDto?.find((item: any) => item.analyticsKey === ANALYTICS_KEYS.PLATFORM_FEE)?.amount,
        additionalCharges: cartConvenienceChargesBreakupDto?.find((item: any) => item.analyticsKey === ANALYTICS_KEYS.ADDITIONAL_CHARGES)?.amount,
        ...getCodAvailableAttributes({ availablePaymentMethods, isCodAvailable }),
      };

      trackPayment1PageLoad(trackingEvents);
      // check for retina tracking  for web  though code directly
      const retinaPage1Data = getRetinaPayment1LoadData(cartInfo, paymentInfo);
      triggerRetinaEventForWeb(isApp, retinaPage1Data);
      // page load tracking for apps
      allTrackingHandlerForApps({
        event: TRACKING_EVENTS.SAVED_PAYMENT_LOADS,
        cartInfo,
        paymentInfo,
        walletInfo,
        offersData,
        walletConfig,
        isApp,
        visibleOffers,
        failureFlowEnabled,
        isFirstLandingPageAfterCheckout,
      });

      setIsFirstLandingPageAfterCheckout(false);
      setCheckoutSuccessToFalseInDataLayer();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products?.length, isVisible, isPaymentInfoLoading]);
  // }, [products?.length, loading]);  // loading was firing tracking on UPI timer screen also TODO - remove later

  /**
   * if there is no savedPayment then set payment option to NEW.
   */
  useEffect(() => {
    if (!isSavedPaymentVisible) {
      setPaymentOption(PAYMENT_OPTION.NEW);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSavedPaymentVisible]);


  return (
    <Main className={`layout vertical ${isVisible ? "visible-layer" : "hidden-layer"}`}>
      {showDiscountInfoStrip && <DiscountInfoStrip discountText={discountText} />}
      {isBuyNowFlow() ? (
        <SavePaymentBuyNowView
          setIsWalletChecked={setIsWalletChecked}
          timerCallback={timerCallback}
          setUpiDetails={setUpiDetails}
          isGPayIntentAvailable={isGPayIntentAvailable}
          loading={loading}
          showAllPaymentMethods={showAllPaymentMethods}
          setPaymentScreen={setPaymentScreen}
          isDeliveryEstimateToastVisible={isDeliveryEstimateToastVisible}
          setIsDeliveryEstimateToastVisible={setIsDeliveryEstimateToastVisible}
          areSavedPaymentMethodsDisplayed={areSavedPaymentMethodsDisplayed}
          isSavedPaymentVisible={isSavedPaymentVisible}
          isNewPaymentMethodVisible={isNewPaymentMethodVisible}
          isWalletDisplayed={isWalletDisplayed}
          newPaymentMethod={newPaymentMethod}
          priceDetailConfig={priceDetailConfig}
          proceedToPayVisible={proceedToPayVisible}
          isFailureUrl={isFailureUrl}
        />
      ) : (
        <SavePaymentView
          setIsWalletChecked={setIsWalletChecked}
          timerCallback={timerCallback}
          setUpiDetails={setUpiDetails}
          isGPayIntentAvailable={isGPayIntentAvailable}
          loading={loading}
          showAllPaymentMethods={showAllPaymentMethods}
          setPaymentScreen={setPaymentScreen}
          isDeliveryEstimateToastVisible={isDeliveryEstimateToastVisible}
          setIsDeliveryEstimateToastVisible={setIsDeliveryEstimateToastVisible}
          areSavedPaymentMethodsDisplayed={areSavedPaymentMethodsDisplayed}
          isSavedPaymentVisible={isSavedPaymentVisible}
          isNewPaymentMethodVisible={isNewPaymentMethodVisible}
          isWalletDisplayed={isWalletDisplayed}
          newPaymentMethod={newPaymentMethod}
          priceDetailConfig={priceDetailConfig}
          proceedToPayVisible={proceedToPayVisible}
          isFailureUrl={isFailureUrl}
        />
      )}
      {flowConfig?.showProceedButton && proceedToPayVisible && !isPaymentInfoLoading && (
        <PlaceOrderButton
          onSubmit={doPaymentInterceptor}
          proceedToPayText={proceedToPayText}
          disabled={cartErrorMessage || isPaymentInfoLoading}
          setPaymentScreen={setPaymentScreen}
          orderAmount={orderAmount}
          isFullPaymentByGiftCard={isFullPaymentByGiftCard}
        />
      )}
      {isSavedPayment && showFallbackModeSheet && (
        <NewPaymentFailureFlow
          showFallbackModeSheet={showFallbackModeSheet}
          theme={theme}
          setShowFallbackModeSheet={setShowFallbackModeSheet}
          isGPayIntentAvailable={isGPayIntentAvailable}
          timerCallback={timerCallback}
        />
      )}
    </Main>
  );
};
export default AllSavedPaymentMethod;
